import { Textual }		from "@v3/data/textual";

import { CookieValue }	from "@v3/data/primitive/cookieValue";

export type Secret	= Textual.Value<typeof Base>;

const Base	= Textual.unrestricted("Secret");

namespace Extension {
	export const toCookieValue	= (it:Secret):CookieValue	=>
		// this is safe, CookieValue allows all characters encodeURIComponent produces
		CookieValue.brand(encodeURIComponent(it));
}

export const Secret	= { ...Extension, ...Base };
